import type { PropsWithChildren } from 'react';
import React from 'react';
import { TPAComponentsProvider } from 'wix-ui-tpa/TPAComponentsConfig';
import { useMenusContext } from 'root/contexts/MenusContext';
import { classes } from './rtl.st.css';

export const RtlProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { isRTL } = useMenusContext();

  return (
    <TPAComponentsProvider value={{ rtl: isRTL }}>
      <div className={classes.rtlWrapper} dir={isRTL ? 'rtl' : 'ltr'}>
        {children}
      </div>
    </TPAComponentsProvider>
  );
};
